import * as React from "react";
import { FaSearch } from 'react-icons/fa';
import {
  View,
  StyleSheet,
  ImageBackground,
  Text,
  TextInput,
  TouchableOpacity,
  Picker,
  useWindowDimensions,
} from "react-native";
import "./AuthenticityCheck.css";
import { FaCheckCircle } from "react-icons/fa";
import { RxCrossCircled } from "react-icons/rx";
import Header from "./Header";
import Footer from "./Footer";

function AuthenticityCheck() {
  const [selectedOption, setSelectedOption] = React.useState("Telegram");
  const [inputValue, setInputValue] = React.useState("");
  const [warningMessage, setWarningMessage] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("");
  const { width } = useWindowDimensions();
  const isMobile = width < 991;
  const responsiveStyles = isMobile ? stylesMobile : stylesDesktop;

  const handleSearch = () => {
    const telegramAccounts = ["@rndrpk", "@Desmond_KIY"];
    const emailAccounts = [
      "desmond.hsu@keepityourself.com",
      "rendy@keepityourself.com",
      "partnership@keepityourself.com",
    ];

    if (selectedOption === "Telegram") {
      if (telegramAccounts.includes(inputValue)) {
        setSuccessMessage(
          `Yes! ${inputValue} is the official domain or account of keepityourself.com`
        );
        setWarningMessage("");
      } else {
        setWarningMessage(
          `Alert! ${inputValue} is not officially released by keepityourself`
        );
        setSuccessMessage("");
      }
    } else if (selectedOption === "Email") {
      if (emailAccounts.includes(inputValue)) {
        setSuccessMessage(
          `Yes! ${inputValue} is the official domain or account of keepityourself.com`
        );
        setWarningMessage("");
      } else {
        setWarningMessage(
          `Alert! ${inputValue} is not officially released by keepityourself`
        );
        setSuccessMessage("");
      }
    }
  };

  return (
    <>
      <Header />
      <ImageBackground
        resizeMode="cover"
        source={{
          uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/ba3444f1509b1aea3d3df39d76818f312eae5f38?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc",
        }}
        style={responsiveStyles.image1}
      >
        <div className="authenticity" style={{ textAlign: "left", marginLeft: "25%" }}>Authenticity Check</div>
        <View>
          <Text style={responsiveStyles.view1}>
            Enter your search term in the box to confirm the authenticity of
            Keepityourself’s domain or employee (e.g. website links, social media account, employee email).
          </Text>
        </View>
        <View style={responsiveStyles.view2}>
          <View style={responsiveStyles.row}>
            <Picker
              selectedValue={selectedOption}
              onValueChange={(itemValue) => setSelectedOption(itemValue)}
              style={responsiveStyles.picker}
            >
              <Picker.Item label="Telegram" value="Telegram" />
              <Picker.Item label="Email" value="Email" />
            </Picker>
            <TextInput
              style={responsiveStyles.inputBox}
              placeholder={
                selectedOption === "Telegram"
                  ? "e.g: @example"
                  : "e.g: example@keepityourself.com"
              }
              value={inputValue}
              onChangeText={(text) => setInputValue(text)}
            />
            <TouchableOpacity style={responsiveStyles.searchButton} onPress={handleSearch}>
            {isMobile ? <FaSearch color="white"/> : <Text style={responsiveStyles.searchButtonText}>Search</Text>}
            </TouchableOpacity>
          </View>
          {successMessage ? (
            <View style={responsiveStyles.messageRow}>
              <FaCheckCircle responsiveStyles={responsiveStyles.successIcon} />
              <Text style={responsiveStyles.successMessage}>{successMessage}</Text>
            </View>
          ) : null}
          {warningMessage ? (
            <View style={responsiveStyles.messageRow}>
              <RxCrossCircled style={responsiveStyles.warningIcon} />
              <Text style={responsiveStyles.warningMessage}>{warningMessage}</Text>
            </View>
          ) : null}
        </View>
      </ImageBackground>
      <Footer />
    </>
  );
}

const stylesMobile = StyleSheet.create({
  image1: {
    position: "relative",
    display: "flex",
    height: "100%",
    width: "100%",
    paddingTop: 80,
    paddingBottom: 350,
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "center", // Center content horizontally
    fontWeight: "400",
    aspectRatio: "1.41",
  },

  
  view1: {
    color: "white", // Changed to white
    fontSize: "12px",
    fontFamily: "'Montserrat', sans-serif",
    position: "relative",
    marginTop: 31,
    width: "75%",
    marginLeft: "10%",
    lineHeight: "20px",
  },
  view2: {
    position: "relative",
    display: "flex",
    marginTop: 40,
    alignItems: "stretch",
    gap: 16,
    fontFamily: "'Montserrat', sans-serif",
    fontSize: "12px",
    flexWrap: "wrap",
    width: "90%",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
    width: "100%",
    // paddingLeft: "1.25",
    // paddingRight: 3,
  },
  picker: {
    flex: 1,
    borderRadius: 8,
    borderColor: "rgba(209, 213, 219, 1)",
    borderWidth: 1,
    // padding: 10,
    marginRight: "2.5%",
    height: "100%", // Set height to match the button
    fontSize: "14px", // Adjust font size
    fontFamily: "'Montserrat', sans-serif",
  },
  inputBox: {
    flex: 5,
    borderRadius: 8,
    borderColor: "rgba(209, 213, 219, 1)",
    borderWidth: 1,
    padding: 10,
    marginRight: "2.5%",
    height: "100%", // Set height to match the button
    fontSize: "14px", // Adjust font size
    backgroundColor: "white", // Set background to white
    color: "black", // Set font color to black
    fontFamily: "'Montserrat', sans-serif",
    width: "70%"
  },
  searchButton: {
    flex: 0.5,
    borderRadius: 8,
    backgroundColor: "rgba(0, 122, 255, 1)",
    padding: 15,
    alignItems: "center",
    height: 50, // Ensure consistent height
    justifyContent: "center", // Center text vertically
  },
  searchButtonText: {
    color: "white",
    fontWeight: "600",
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  messageRow: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: "18%",
    marginTop: 10,
  },
  successIcon: {
    color: "green",
    marginRight: 8,
    fontSize: 20,
  },
  warningIcon: {
    color: "red",
    marginRight: 8,
    fontSize: 20,
  },
  successMessage: {
    color: "green",
    fontFamily: "'Montserrat', sans-serif",
  },
  warningMessage: {
    color: "red",
    fontFamily: "'Montserrat', sans-serif",
  },
});

const stylesDesktop = StyleSheet.create({
  image1: {
    position: "relative",
    display: "flex",
    height: 800,
    width: "100%",
    paddingTop: 128,
    paddingBottom: 528,
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "center", // Center content horizontally
    fontWeight: "400",
    aspectRatio: "1.41",
  },

  
  view1: {
    color: "white", // Changed to white
    fontSize: 25, // Increased font size
                    fontFamily: "'Montserrat', sans-serif",
    position: "relative",
    marginTop: 31,
    width: "75%",
    marginLeft: "12.5%"
  },
  view2: {
    position: "relative",
    display: "flex",
    marginTop: 112,
    alignItems: "stretch",
    gap: 16,
    fontFamily: "'Montserrat', sans-serif",
    fontSize: 24,
    flexWrap: "wrap",
    width: "75%",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
    width: "100%",
    paddingLeft: "1.25",
    paddingRight: 3,
  },
  picker: {
    flex: 1,
    borderRadius: 8,
    borderColor: "rgba(209, 213, 219, 1)",
    borderWidth: 1,
    padding: 10,
    marginRight: "2.5%",
    height: 50, // Set height to match the button
    fontSize: 16, // Adjust font size
    fontFamily: "'Montserrat', sans-serif",
  },
  inputBox: {
    flex: 5,
    borderRadius: 8,
    borderColor: "rgba(209, 213, 219, 1)",
    borderWidth: 1,
    padding: 10,
    marginRight: "2.5%",
    height: 50, // Set height to match the button
    fontSize: 16, // Adjust font size
    backgroundColor: "white", // Set background to white
    color: "black", // Set font color to black
    fontFamily: "'Montserrat', sans-serif",
  },
  searchButton: {
    flex: 0.5,
    borderRadius: 8,
    backgroundColor: "rgba(0, 122, 255, 1)",
    padding: 15,
    alignItems: "center",
    height: 50, // Ensure consistent height
    justifyContent: "center", // Center text vertically
  },
  searchButtonText: {
    color: "white",
    fontWeight: "600",
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  messageRow: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: "18%",
    marginTop: 10,
  },
  successIcon: {
    color: "green",
    marginRight: 8,
    fontSize: 20,
  },
  warningIcon: {
    color: "red",
    marginRight: 8,
    fontSize: 20,
  },
  successMessage: {
    color: "green",
    fontFamily: "'Montserrat', sans-serif",
  },
  warningMessage: {
    color: "red",
    fontFamily: "'Montserrat', sans-serif",
  },
});

export default AuthenticityCheck;

